import React from 'react'
import Link from '../../utils/link'

import { Bed, Bath, Car } from '../icons'
import Auction from '../../assets/images/auction.svg'
import Inspection from '../../assets/images/inspection.svg'

const PropertyCard = (props) => {
  return (
    <div className='card card--property'>
      <div className='card__image'>
        <img src={props.image} alt={props.title ? props.title : ''} />
        { props.tag && <span className={`card__tag ${props.tag === 'Sold' && 'card__tag--sold'}`}>{props.tag}</span> }
      </div>
      <div className='card__content'>
        <h4>{props.address}</h4>
        <div className='card__features'>
          <ul className='card__specs'>
            { props.beds && 
              <li>
                <span>{props.beds}</span>
                <Bed color={'#1C1C1C'} />
              </li>
            }
            { props.baths && 
              <li>
                <span>{props.baths}</span>
                <Bath color={'#1C1C1C'} />
              </li>
            }
            { props.cars && 
              <li>
                <span>{props.cars}</span>
                <Car color={'#1C1C1C'} />
              </li>
            }
          </ul>
          <span className='card__price' dangerouslySetInnerHTML={{ __html: props.price }} />
          { props.inspection && 
            <div className='card__docs'>
              <img src={Inspection} alt='Hodges - Inspection' />
              <span>{props.inspection}</span>
            </div>
          }
          { !props.inspection && props.auction &&
            <div className='card__docs'>
              <img src={Auction} alt='Hodges - Auction' />
              <span>{props.auction}</span>
            </div>
          }
        </div>
      </div>
      <Link className='card__link' to={props.link}></Link>
    </div>
  )
}

export default PropertyCard